import styled from "styled-components";

export default function HomepageCardButton({
  children,
  onClick = (event) => {}
}) {
  return (
    <Button onClick={onClick}>
      {children}
    </Button>
  )
}

const Button = styled.button`
  flex: 1;
  background-color: #1d1d1b;
  border: 0;
  width: 100%;
  padding: .3125rem .625rem;
  border-radius: .3125rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: .5rem;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
  }
`
